const state = {
  alert: {
    loading: false,
    busy: false,
    type: null,
    message: null,
  },
};

const actions = {
  success({ commit }, message) {
    commit('success', message);
    setTimeout(() => {
      commit('clear');
    }, 5000);
  },
  error({ commit }, message) {
    commit('error', message);
    setTimeout(() => {
      commit('clear');
    }, 5000);
  },
  info({ commit }, message) {
    commit('info', message);
    setTimeout(() => {
      commit('clear');
    }, 10000);
  },
  clear({ commit }) {
    commit('clear');
  },
  busy({ commit }) {
    commit('busy');
  },
  loading({ commit }) {
    commit('loading');
  },
};

const mutations = {
  success(state, message) {
    state.alert.busy = false;
    state.alert.type = 'alert-success';
    state.alert.message = message;
  },
  error(state, message) {
    state.alert.busy = false;
    state.alert.type = 'alert-danger';
    state.alert.message = message;
  },
  info(state, message) {
    state.alert.busy = false;
    state.alert.type = 'alert-primary';
    state.alert.message = message;
  },
  clear(state) {
    state.alert.busy = false;
    state.alert.loading = false;
    state.alert.type = null;
    state.alert.message = null;
  },
  loading(state) {
    state.alert.loading = true;
  },
  busy(state) {
    state.alert.busy = true;
  },
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/alert.module.js